import "@babel/polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from "history";

import App from './App';

const baseUrl = document.getElementById('baseRelativePath').getAttribute('href');
const rootElement = document.getElementById('root');

const history = createBrowserHistory({ basename: '' })

ReactDOM.render(
    <BrowserRouter history={history} >
        <App />
    </BrowserRouter>,
    rootElement
);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(`${baseUrl}service-worker.js`, { scope: baseUrl }).then(registration => {
            console.log('SW registered');
        }).catch(registrationError => {
            console.log('SW registration failed: ', registrationError);
        });
    });
}
